<template>
  <p>score</p>
</template>

<script>
export default {

}
</script>

<style>

</style>